import React from 'react';
import styled from 'styled-components';
import { colors } from "nxtconstants";
import { WealthyEnv } from "helpers";


const ReadyToGrow = ({ readyData = {} }) => {
  return (
    <Section>
      <Container>
        <ContentWrapper>
          <ImgContainer>
            <TeamImage
              src={readyData.image}
              alt="Wealthy Partner Support Team helping Mutual Fund Distributors"
            />
          </ImgContainer>
          <TextContent>
            <MainHeading>
              {readyData.heading && (
                <>
                  {readyData.heading.main}
                  <span>{readyData.heading.highlight}</span>
                </>
              )}
            </MainHeading>

            <Description>
              {readyData.description}
            </Description>

            <ButtonSection>
              <CTAButton href="#register">
                <ButtonIcon src={readyData.buttonIcon} alt=" Wealthy Logo Icon" />
                {readyData.ctaText}
              </CTAButton>
            </ButtonSection>
          </TextContent>
        </ContentWrapper>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  width: 100%;
  background: ${colors.white};
  display: flex;
  overflow: hidden;
  margin-top: 10rem;

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 5rem;
    min-height: auto;
    margin-bottom: 5.6rem;
  }
`;

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    width: 90%;
    margin: 0 auto;
    padding: 0;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 3rem;

  @media (max-width: 768px) {
    gap: 2rem;
    margin: 0 auto;
    width: 90%;
  }
`;

const TeamImage = styled.img`
  width: 70rem;
  border-radius: 2rem;

  @media (max-width: 768px) {
    border-radius: 1.4rem;
    width:100%;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  max-width: 80rem;

  @media (max-width: 768px) {
    gap: 1.5rem;
  }
`;

const ImgContainer = styled.div`
  width: 100%; 
  max-width: 125rem;
  margin: 0 auto;
  `;

const MainHeading = styled.h2`
  font-family: 'DM Serif Display';
  font-size: 5rem;
  font-weight: 400;
  color: ${colors.textBlack};
  line-height: 1.2;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 2.7rem;
    font-weight: 400;
  }
`;

const Description = styled.p`
  font-family: 'Lato';
  font-size: 2rem;
  font-weight: 400;
  color: ${colors.textGray};
  line-height: 3.2rem;
  margin: 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.4rem;
    line-height: 2.3rem;
  }
`;

const ButtonIcon = styled.img`
  width: 1.8rem;
  height: 2.1rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const ButtonSection = styled.div`
    text-align: center;
`;

const CTAButton = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: ${colors.primary};
  color: white;
  border: none;
  border-radius: 5rem;
  padding: 1rem 4rem;
  font-family: 'Lato';
  font-size: 1.8rem;
  font-weight: 700;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;

  @media (max-width: 768px) {
    padding: 1rem 12rem;
    font-size: 1.4rem;
  }
`;
export default ReadyToGrow;